export const ru = {
    show_more: 'Показать ещё',
};
